// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// SURFACE SUBSIDIARY SCHEMA
/////////////////////////////////////////

export const SurfaceSubsidiarySchema = z.object({
  name: z.string(),
  description: z.string().nullable(),
  location: z.string().nullable(),
})

export type SurfaceSubsidiary = z.infer<typeof SurfaceSubsidiarySchema>

export default SurfaceSubsidiarySchema;
